import { render, staticRenderFns } from "./hong_bao_yu.vue?vue&type=template&id=4da9ac8b&scoped=true"
import script from "./hong_bao_yu.vue?vue&type=script&lang=ts"
export * from "./hong_bao_yu.vue?vue&type=script&lang=ts"
import style0 from "./hong_bao_yu.vue?vue&type=style&index=0&id=4da9ac8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9ac8b",
  null
  
)

export default component.exports